import {getSizes, IconProps} from "@/base/components/icon/IconBase";

export const IconChartOutlined = (props: IconProps) => {
	const [width, height] = getSizes(props.width, props.height, 30, 30);
	return <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} style={props.style || {}} viewBox="0 0 30 30" fill="none" className={`!text-primary ${props.className || ''}`}>
		<path d="M26.25 25H3.75V6.25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M26.25 8.75L16.25 17.5L11.25 12.5L3.75 18.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		{props.children}
	</svg>
}